import { defineFieldFormInterface } from "~/entities/field";
import SelectIconInterface from "./SelectIconInterface.vue";

export default defineFieldFormInterface({
  interface: "select-icon",
  component: SelectIconInterface,
});
